import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-editmodalcomp',
  templateUrl: './editmodalcomp.component.html',
  styleUrls: ['./editmodalcomp.component.scss']
})
export class EditmodalcompComponent implements OnInit {

  constructor() { }
  @Output() eModal: EventEmitter<any> = new EventEmitter();
  ngOnInit(): void {
  }
  sendCEM() {
    this.eModal.emit(false);
  } 
}
